import React from 'react';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { Box, Tooltip, useTheme } from '@mui/material';

import { CopyToClipboard } from 'react-copy-to-clipboard';

const ButtonCopy = ({ text }: { text: string }) => {
    const theme = useTheme();
    const [onCopy, setOnCopy] = React.useState({ colorIcon: theme.palette.primary.dark, textContent: 'Click to copy' });

    const OnCopy = () => {
        setOnCopy({ colorIcon: theme.palette.success.main, textContent: 'Copied' });
        setTimeout(() => {
            setOnCopy({ colorIcon: theme.palette.primary.dark, textContent: 'Click to copy' });
        }, 1500);
    };
    return (
        <Tooltip title={onCopy.textContent} placement="top" arrow sx={{ cursor: 'pointer' }}>
            <Box display="flex" justifyContent="center" alignItems="center">
                <CopyToClipboard text={text} onCopy={() => OnCopy()}>
                    <FileCopyIcon sx={{ fontSize: '0.875rem', color: onCopy.colorIcon }} />
                </CopyToClipboard>
            </Box>
        </Tooltip>
    );
};

export default ButtonCopy;
